import { TimeshiftAvatar } from '@/components/shared/TimeshiftAvatar';
import { WarningPopup } from '@/pages/roster/staffPicker/warningsIndicator/WarningPopup';
import { getSeverityType } from '@/services/warnings/severityHelper';
import { EmployeeForShiftItem } from '@/types/employeeForShift.types';
import { FC } from 'react';
import { useWarningsForShift } from '../../providers/RosterWarningsService';
import { RosterPickerIcon } from '../RosterPickerIcon';
import { WarningsList } from './WarningsList';

interface Props {
  shiftId: string;
  selectedUser?: EmployeeForShiftItem;
}

export const WarningsIndicator: FC<Props> = ({ shiftId, selectedUser }) => {
  const warnings = useWarningsForShift(shiftId);
  const severity = getSeverityType(warnings);

  if (warnings.length > 0) {
    return (
      <WarningPopup severity={severity} parentContainerId={'roster-table-wrapper'}>
        <WarningsList warnings={warnings} />
      </WarningPopup>
    );
  }

  if (!selectedUser) {
    return <RosterPickerIcon name={''} />;
  }

  return <TimeshiftAvatar name={selectedUser.name} src={selectedUser.details?.avatarUrl} size={30} />;
};
